
import React, { useState, useEffect } from 'react';
import { number, func, bool } from 'prop-types';
import { Modal } from 'antd';
import { FlexContainer, Icon, Text, Button, Number } from '../../../components/common';

const modalBodyError = () => {
    return (
        <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
            <Icon name='notConnection' color='#1fa02e' size={80} bottom={20} />
            <Text text='Ups, algo falló' strong style={{ fontSize: 16 }} />
            <Text text='Por favor vuelve a intentarlo' />
        </FlexContainer>
    );
};

const modalBodyPreview = (ordersCount) => {
    return (
        <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
            <Icon name='export' color='#1fa02e' size={80} bottom={20} />
            <Text text={<Number isPrice={false} value={ordersCount} />} strong style={{ fontSize: 16 }} />
            <Text text='Registros se van a exportar' />
        </FlexContainer>
    );
};

const finalText = (type) => {
    switch (type) {
        case 5:
            return 'de ayer hasta hoy';
        case 6:
            return 'correctamente';
        default:
            return 'seleccionados';
    }
};

const modalBodySuccess = (typeReport) => {
    const msgSuccess = `Se exportaron los registros ${finalText(typeReport)}`;
    return (
        <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
            <Icon name='check-mark' color='#1fa02e' size={80} bottom={20} />
            <Text text={msgSuccess} strong style={{ fontSize: 16 }} />
            <Text text='Serán enviados dentro de unos minutos a tu correo' />
        </FlexContainer>
    );
};

const ModalActions = ({ ordersCount, typeReport, callExportQuery, setVisibleModal, visibleModal, setRefreshRightHeader, refreshRightHeader }) => {
    const [showBodyModalError, setShowBodyModalError] = useState(false);
    const [showBodyModalSuccess, setShowBodyModalSuccess] = useState(false);
    const [showBodyModalPreview, setShowBodyModalPreview] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const handleConfirm = () => {
        setLoadingExport(true);
        callExportQuery(1)
            .then(() => {
                setShowBodyModalPreview(false);
                setShowBodyModalSuccess(true);
            })
            .catch(() => {
                setShowBodyModalPreview(false);
                setShowBodyModalError(true);
            })
            .finally(() => {
                setLoadingExport(false);
                setTimeout(() => setRefreshRightHeader(!refreshRightHeader), 10000);
            });
    };

    useEffect(() => {
        setShowBodyModalSuccess(typeReport === 5 || typeReport === 6);
        setShowBodyModalPreview(typeReport === 1 && typeReport !== 6);
    }, [typeReport]);

    const handleCancel = () => {
        setVisibleModal(false);
        setRefreshRightHeader(!refreshRightHeader);
    };

    return (
        <Modal
            visible={visibleModal}
            footer={null}
            closable={false}
            width={450}
            destroyOnClose
            onCancel={() => handleCancel()}
        >
            {showBodyModalError && modalBodyError()}
            {showBodyModalSuccess && modalBodySuccess(typeReport)}
            {showBodyModalPreview && modalBodyPreview(ordersCount)}
            <FlexContainer justify='center' align='center' style={{ width: '100%' }}>
                <Button
                    link={!showBodyModalSuccess}
                    text={!showBodyModalSuccess ? 'btn.action.cancel' : 'btn.action.close'}
                    style={{ width: '100px', margin: 0 }}
                    onClick={() => handleCancel()}
                />
                { !showBodyModalSuccess &&
                    <Button
                        loading={loadingExport}
                        text={!showBodyModalError ? 'btn.action.confirm' : 'btn.action.retry'}
                        style={{ width: '100px', margin: 0 }}
                        onClick={() => handleConfirm()}
                    />
                }
            </FlexContainer>
        </Modal>
    );
};

ModalActions.propTypes = {
    ordersCount: number,
    typeReport: number,
    callExportQuery: func,
    setVisibleModal: func,
    visibleModal: bool,
    setRefreshRightHeader: func,
    refreshRightHeader: bool
};

export default ModalActions;
